import { render, staticRenderFns } from "./product-filter-bar.vue?vue&type=template&id=f47ee21a&"
import script from "./product-filter-bar.vue?vue&type=script&lang=js&"
export * from "./product-filter-bar.vue?vue&type=script&lang=js&"
import style0 from "./product-filter-bar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports